import { Injectable } from '@angular/core';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { BehaviorSubject, Subject } from 'rxjs';
import * as config from '../shared/config/app.config';
import { BaseService } from '../shared/services/base.service';
import { ExcelDownloadService } from '../shared/services/excel-download.service';

@Injectable({
  providedIn: 'root'
})
export class MessageHistoryService {
  // public notificationData = new BehaviorSubject<any>(null);
  public notificationData = new Subject<any>();
  notificationData$ = this.notificationData.asObservable();

  // public notificationDetails = new BehaviorSubject<any>(null);
  public notificationDetails = new Subject<any>();
  notificationDetails$ = this.notificationDetails.asObservable();

  public allOrders = new BehaviorSubject<any>(null);
  allOrders$ = this.allOrders.asObservable();

  public userAccountDetails = new BehaviorSubject<any>(false);
  userAccountDetails$ = this.userAccountDetails.asObservable();

  userAccountData: any;

  constructor(public baseService: BaseService,
    public excelService: ExcelDownloadService,
    private globalMessage: GlobalMessageService) {
    this.userAccountData = new Subject();
  }
  public getNotificationHistory(params, filters?) {
    this.baseService
      .get(`${config.GET_ORDER_HISTORY}${params.userId}/messageCenter/messages?locationId=${params.locId}`, filters)
      .subscribe((res) => {
        this.notificationData.next(res);

      });
  }

  public getNotificationDetails(params, data) {
    return this.baseService
      .post(`${config.GET_ORDER_HISTORY}${params.userId}/messageCenter/messagedetails?fields=DEFAULT`, data)
      .subscribe((res) => {
        this.notificationDetails.next(res);
      });
  }

  public getAttachmentDetails(params, attachdata): void {
    this.baseService.getPdf(`${config.GET_ORDER_HISTORY}${params.userId}/messageCenter/messagedetailsemailpdf?fields=DEFAULT&lang=en&curr=USD`, attachdata)
      .subscribe((res) => {
        const file = new Blob([res], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }, error => {
        this.globalMessage.add('Something went wrong. Please try again', GlobalMessageType.MSG_TYPE_ERROR, 3000);
      });
  }

  public getAllOrders(params, filters) {
    this.baseService
      .get(`${config.GET_ORDER_HISTORY}${params.userId}/orders`, filters)
      .subscribe((res) => {
        this.allOrders.next(res);
      });
  }

  // public getUserAccountDataFromDb(userId): void {
  //   this.baseService
  //     .get(`${config.USER_ACCOUNT}${userId}/b2bUnits/`, { fields: 'FULL' })
  //     .subscribe((res) => {
  //       if (res !== null && res !== undefined && res?.length !== 0) {
  //         this.userAccountData.next(res);
  //       }
  //     });
  // }
  // public getUserAccountDetailsDataFromDb(userId, accountId): void {
  //   this.baseService
  //     .get(`${config.USER_ACCOUNT}${userId}/b2bUnits/${accountId}`, { fields: 'FULL' })
  //     .subscribe((res) => {
  //       if (res !== null && res !== undefined && res?.length !== 0) {
  //         this.userAccountDetails.next(res);
  //       }
  //     });
  // }
}
